import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import ProductCenterPage from '@/views/ProductCenterPage.vue'
import BrandStoryPage from '@/views/BrandStoryPage.vue'
import ContactPage from '@/views/ContactPage.vue'

/**
 * 全站路由：每个 tab 独立 path，刷新/分享链接仍落在当前页
 * meta.tabKey 与顶栏 ActionBar 高亮一致
 */
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: { tabKey: 'home' }
  },
  {
    path: '/product',
    name: 'product',
    component: ProductCenterPage,
    meta: { tabKey: 'product' }
  },
  {
    path: '/brand',
    name: 'brand',
    component: BrandStoryPage,
    meta: { tabKey: 'brand' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage,
    meta: { tabKey: 'contact' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.afterEach((to) => {
  console.info('[Router] 导航完成:', to.fullPath, 'tabKey=', to.meta.tabKey)
})

export default router
